// Finished stop-motion films kept on the device (IndexedDB) so the Film Station can play them.
export type StopFilm = { id: string; title: string; created: number; blob: Blob };

const open = () => new Promise<IDBDatabase>((res, rej) => {
  const r = indexedDB.open("sophia-stopmotion", 1);
  r.onupgradeneeded = () => r.result.createObjectStore("films", { keyPath: "id" });
  r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error);
});

async function tx<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  const db = await open();
  return new Promise((res, rej) => {
    const q = fn(db.transaction("films", mode).objectStore("films"));
    q.onsuccess = () => res(q.result); q.onerror = () => rej(q.error);
  });
}

export const saveStopFilm = (f: StopFilm) => tx("readwrite", (s) => s.put(f));
export const listStopFilms = async () =>
  typeof indexedDB === "undefined" ? [] : ((await tx("readonly", (s) => s.getAll())) as StopFilm[]).sort((a, b) => b.created - a.created);
export const deleteStopFilm = (id: string) => tx("readwrite", (s) => s.delete(id));
